module.exports = __webpack_public_path__ + "img/main-pgcs.b77a2169.png";